import { gql, useMutation } from "@apollo/client";
import React, { ReactElement } from "react";

import { normalizeErrors } from "../../../../utils/normalizeErrors";
import { NormalizedErrorMap } from "../../../../types/NormalizedErrorMap";
import { CreateRefundMutationMutation, CreateRefundMutationMutationVariables } from "../../../../schemaTypes";

export const createRefundMutation = gql`
  mutation CreateRefundMutation(
        $input: CreateRefundInput!
    ) {
        createRefund(
            input: $input
            ) {
            errors {
                path
                message
            }
            message
            data {
                id
                account_number
                bank_code
                full_name
                currency
                debit_currency
                amount
                fee
                status
                reference
                narration
                complete_message
                requires_approval
                is_approved
                bank_name
            }
        }
  }
`;

interface Props {
  children: (
    data: {
      submitCreateRefund: (
        values: CreateRefundMutationMutationVariables
      ) => Promise<NormalizedErrorMap | any>;
      loading: boolean;
      error: any;
      message: string | null;
      createRefundData: any | null; 
    }
  ) => ReactElement | null;
}

export const CreateRefundController: React.FC<Props> = ({ children }) => {
  const [mutate, { loading, error, data }] = useMutation<
    CreateRefundMutationMutation,
    CreateRefundMutationMutationVariables
  >(
    createRefundMutation
  );

  const submitCreateRefund = async (values: CreateRefundMutationMutationVariables) => {
    const { data: {createRefund} }:any = await mutate({ variables: values });

    if (createRefund?.errors) {
      return {error: normalizeErrors(createRefund.errors), createRefund: null};
    }

    return {
      error: null,
      createRefund
    };
  };

  const message = data?.createRefund?.message || null;

  return children({
    submitCreateRefund,
    loading,
    error,
    message,
    createRefundData: data,
  });
};